import { DroneEntity } from "@src/core/features";
import { RouteWaypointEntity, SidebarType } from '@src/features/order/pages/upsert-mission-page/entities';

export enum TerrainMode {
    RELATIVE = 'RELATIVE',
    AMSL = 'AMSL',
    AGL = 'AGL',
}

export interface IUpsertMissionInitialState {
    terrainMode: TerrainMode;
    editableRoute: boolean;
    sidebarType: SidebarType;
    waypoints: RouteWaypointEntity[];
    hoveredDrone: DroneEntity | null;
    selectedDrone: DroneEntity | null;
}